// The people search returns Id as a string, and leaves it out for directory users Tikit has no record of.
export const getStoredUserId = (user: PlatformUser) => Number(user?.Id) || 0;

// Compared as numbers, because the stored user and the picker's value do not agree on Id's type.
export const isStoredUser = (fetched: PlatformUser, storedUserId: number) =>
  storedUserId > 0 && getStoredUserId(fetched) === storedUserId;
